@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.faq.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.faq.generated.resources/"

internal val Res.string.feature_faq: StringResource by lazy {
      StringResource("string:feature_faq", "feature_faq", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1474, 59),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2446, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1094, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1174, 23),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2214, 75),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1046, 23),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1110, 47),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1058, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 986, 27),
      ))
    }

internal val Res.string.feature_faq_answer1: StringResource by lazy {
      StringResource("string:feature_faq_answer1", "feature_faq_answer1", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 10, 323),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 10, 631),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 251),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 275),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 535),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 10, 223),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 263),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 10, 239),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 227),
      ))
    }

internal val Res.string.feature_faq_answer2: StringResource by lazy {
      StringResource("string:feature_faq_answer2", "feature_faq_answer2", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 334, 207),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 642, 303),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 262, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 286, 167),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 546, 299),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 234, 147),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 274, 159),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 250, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238, 143),
      ))
    }

internal val Res.string.feature_faq_answer3: StringResource by lazy {
      StringResource("string:feature_faq_answer3", "feature_faq_answer3", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 542, 319),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 946, 555),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 406, 227),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 454, 243),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 846, 547),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 382, 231),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 434, 231),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 402, 235),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 382, 219),
      ))
    }

internal val Res.string.feature_faq_answer4: StringResource by lazy {
      StringResource("string:feature_faq_answer4", "feature_faq_answer4", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 862, 219),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1502, 279),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 634, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 698, 139),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1394, 275),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 614, 107),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 666, 131),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 638, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 602, 119),
      ))
    }

internal val Res.string.feature_faq_question1: StringResource by lazy {
      StringResource("string:feature_faq_question1", "feature_faq_question1", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1082, 85),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1782, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 774, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 838, 77),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1670, 125),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 722, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 798, 73),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 766, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 722, 65),
      ))
    }

internal val Res.string.feature_faq_question2: StringResource by lazy {
      StringResource("string:feature_faq_question2", "feature_faq_question2", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1168, 129),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1960, 181),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 848, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 916, 105),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1796, 189),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 796, 97),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 872, 93),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 836, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 788, 77),
      ))
    }

internal val Res.string.feature_faq_question3: StringResource by lazy {
      StringResource("string:feature_faq_question3", "feature_faq_question3", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1298, 85),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2142, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 942, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1022, 73),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1986, 97),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 894, 77),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 966, 69),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 926, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 866, 61),
      ))
    }

internal val Res.string.feature_faq_question4: StringResource by lazy {
      StringResource("string:feature_faq_question4", "feature_faq_question4", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1384, 89),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2288, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1016, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1096, 77),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2084, 129),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 972, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1036, 73),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 992, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 928, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_faq", Res.string.feature_faq)
  map.put("feature_faq_answer1", Res.string.feature_faq_answer1)
  map.put("feature_faq_answer2", Res.string.feature_faq_answer2)
  map.put("feature_faq_answer3", Res.string.feature_faq_answer3)
  map.put("feature_faq_answer4", Res.string.feature_faq_answer4)
  map.put("feature_faq_question1", Res.string.feature_faq_question1)
  map.put("feature_faq_question2", Res.string.feature_faq_question2)
  map.put("feature_faq_question3", Res.string.feature_faq_question3)
  map.put("feature_faq_question4", Res.string.feature_faq_question4)
}
